<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Andrew has a PhD in environmental and marine science, Grad. Cert. in strategic studies and a Grad. Dip. Ed. He has published in peer-reviewed science journals and co-founded the New Zealand Aquaculture Magazine. Andrew has served as a watch keeping officer in the navy. He has lectured and taught statistics, marine and maritime studies at a technical institute. During this period, he consulted to the fisheries and aquaculture industry. Subsequently, Andrew contracted to the offshore oil and gas industry in environmental management. He then taught secondary school science and mathematics and is a future schools STEM industry focus advocate.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?2d6555ec